import { render, staticRenderFns } from "./ResponsibleGaming.vue?vue&type=template&id=0688c5c6&scoped=true"
import script from "./ResponsibleGaming.vue?vue&type=script&lang=js"
export * from "./ResponsibleGaming.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleGaming.vue?vue&type=style&index=0&id=0688c5c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688c5c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0688c5c6')) {
      api.createRecord('0688c5c6', component.options)
    } else {
      api.reload('0688c5c6', component.options)
    }
    module.hot.accept("./ResponsibleGaming.vue?vue&type=template&id=0688c5c6&scoped=true", function () {
      api.rerender('0688c5c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/footer-pages/responsible-gaming/ResponsibleGaming.vue"
export default component.exports